import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFolderOpen } from 'react-icons/fa';
import '../../styles/Navigation.css';

const Navigation = ({ user, signOut }) => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };
  
  return (
    <header className="app-header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <FaFolderOpen className="logo-icon" />
            <h1>MMF File Organizer</h1>
          </Link>
        </div>
        
        <nav className="main-nav">
          <ul>
            <li className={isActive('/dashboard')}>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className={isActive('/settings')}>
              <Link to="/settings">Settings</Link>
            </li>
          </ul>
        </nav>
        
        <div className="user-menu">
          <span className="username">
            {user?.username || (user?.attributes?.email) || 'User'}
          </span>
          <button onClick={signOut} className="signout-button">Sign Out</button>
        </div>
      </div>
    </header>
  );
};

export default Navigation;